// extracted by mini-css-extract-plugin
module.exports = {"root":"Welcome_root__N89t9","root_main":"Welcome_root_main__dVeNH"};